import { config, set, event, pageview } from 'vue-gtag';
const useGA = () => {
    return {
        set,
        config,
        event,
        pageview
    };
};
export default useGA;
//# sourceMappingURL=useGA.js.map